import React, { useState } from "react";
import Divider from "@/components/Divider";
import Panel from "@/components/Kendo/Window/Panel";
import LoadingPanel from "@/components/LodingPanel";
import useFormPropRef from "@/hooks/useFormPropRef";
import useWindowSize from "@/hooks/useWindowSize";

export interface ReleasePanelProps {
  title: string;
  link: string;
  widthInPercentage?: number;
  height?: number;
  onClose: () => void;
}

const ReleaseUpdates: React.FC<ReleasePanelProps> = ({
  title,
  link,
  onClose,
  widthInPercentage = 60,
  height: heightProps,
}) => {
  const [isLoading, setLoading] = useState<boolean>(true);
  const [formRef] = useFormPropRef();
  const { height } = useWindowSize();
  const _height = heightProps || height;
  return (
    <Panel
      title={title}
      description={""}
      onClose={onClose}
      formRenderProps={formRef}
      isLoading={false}
      //isSubmitting={componentState.isSaving}
      submitText={"Change Password"}
      withInPercentage={widthInPercentage}
      height={_height}
    >
      <Divider />
      <LoadingPanel isLoading={isLoading} />
      <iframe
        src={link}
        title="description"
        height={isLoading ? 0 : _height - (heightProps ? 0 : 150)}
        width={"100%"}
        style={{ border: "none" }}
        onLoad={() => setLoading(false)}
      ></iframe>
    </Panel>
  );
};

export default ReleaseUpdates;
